import { FileSearch } from 'lucide-react';

import { humanizeLabel } from '@/nucleo/displayLabels';
import { formatarData } from '@/nucleo/formato/datas';
import { EmptyState } from '@/ui/EmptyState';
import { Spinner } from '@/ui/Spinner';
import { Badge } from '@/ui/base/badge';
import { Card, CardContent } from '@/ui/base/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/ui/base/table';

import { useProcessosSeiDoCredenciado } from './detalheDados';

interface AbaProcessosSeiProps {
  credenciadoId: string;
}

/**
 * Aba "Processos SEI". SEM CLIQUE NA LINHA DE PROPOSITO: o protótipo levava a
 * `/sei/:id`, rota que nao existe aqui — ver o mesmo raciocinio em `AbaTermos`.
 */
export function AbaProcessosSei({ credenciadoId }: AbaProcessosSeiProps) {
  const { data: processos, isLoading } = useProcessosSeiDoCredenciado(credenciadoId);

  return (
    <Card>
      <CardContent className="p-6">
        {isLoading ? (
          <Spinner size="sm" />
        ) : !processos || processos.length === 0 ? (
          <EmptyState
            icon={FileSearch}
            title="Nenhum processo SEI"
            description="Processos vinculados a este credenciado aparecerão aqui."
          />
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Nº SEI</TableHead>
                <TableHead>Tipo</TableHead>
                <TableHead>Status</TableHead>
                <TableHead>Abertura</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {processos.map((processo) => (
                <TableRow key={processo.id}>
                  <TableCell className="font-mono">{processo.numero_sei}</TableCell>
                  <TableCell>{humanizeLabel(processo.tipo_processo)}</TableCell>
                  <TableCell>
                    <Badge variant="outline">{humanizeLabel(processo.status_sei)}</Badge>
                  </TableCell>
                  <TableCell>{formatarData(processo.data_abertura)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
}
